import { FC } from 'react'
import useWindowSize from './util/useWindowSize'
import { generateSrcSet } from 'project/image-proxy-web'
import { AppStoreButton, GooglePlayButton } from './AppDownloadButtons'

export type RatingsType = {}

export const Ratings: FC<RatingsType> = () => {
  const size = useWindowSize()
  return (
    <>
      {size.isLgOrHigher ? (
        <ul className='list-unstyled d-lg-flex d-none mt-8 rating-logos'>
          <li>
            <a
              href={
                'https://registry.blockmarktech.com/certificates/af0f0105-1863-4e02-a5d5-f2548d77bc2a/'
              }
              target={'_blank'}
              rel='noopener noreferrer'
            >
              <img
                {...generateSrcSet(
                  '/images/logos/cyber-essentials-certified-plus.svg',
                  72,
                  72,
                )}
                loading='lazy'
                className='img-fluid'
                alt='LW Rating Icon'
                width={72}
                height={72}
              />
            </a>
          </li>
          <li>
            <img
              {...generateSrcSet('/images/ratings/lw-logo.svg', 72, 57)}
              loading='lazy'
              className='img-fluid'
              alt='LW Rating Icon'
              width={72}
              height={57}
            />
          </li>
          <li>
            <img
              {...generateSrcSet(
                '/images/ratings/homepage-google-footer-icon-desktop.svg',
                84,
                55,
              )}
              loading='lazy'
              className='img-fluid'
              alt='Google Rating Icon'
              width={84}
              height={55}
            />
          </li>
          <li>
            <img
              {...generateSrcSet(
                '/images/ratings/homepage-ico-footer-icon-desktop.svg',
                94,
                55,
              )}
              loading='lazy'
              className='img-fluid'
              alt='ICO Rating Icon'
              width={94}
              height={55}
            />
          </li>
          <li>
            <img
              {...generateSrcSet(
                '/images/ratings/homepage-cloudflare-footer-icon-desktop.svg',
                101,
                62,
              )}
              loading='lazy'
              className='img-fluid'
              alt='SSL Icon'
              width={101}
              height={62}
            />
          </li>
          <li className='pe-5'>
            <AppStoreButton />
          </li>
          <li className='ps-0'>
            <GooglePlayButton />
          </li>
        </ul>
      ) : (
        <ul className='list-unstyled d-flex gap-5 d-lg-none mt-8 mb-6 rating-logos mx-n4'>
          <li>
            <a
              href={
                'https://registry.blockmarktech.com/certificates/af0f0105-1863-4e02-a5d5-f2548d77bc2a/'
              }
              target={'_blank'}
              rel='noopener noreferrer'
            >
              <img
                {...generateSrcSet(
                  '/images/ratings/cyber-essentials.png',
                  72,
                  57,
                )}
                loading='lazy'
                className='img-fluid'
                alt='LW Rating Icon'
                width={72}
                height={57}
              />
            </a>
          </li>
          <li>
            <img
              {...generateSrcSet(
                '/images/ratings/homepage-google-footer-icon-desktop.svg',
                84,
                55,
              )}
              loading='lazy'
              className='img-fluid'
              alt='Google Rating Icon'
              width={84}
              height={55}
            />
          </li>
          <li>
            <img
              {...generateSrcSet('/images/ratings/lw-logo.svg', 72, 57)}
              loading='lazy'
              className='img-fluid'
              alt='LW Rating Icon'
              width={72}
              height={57}
            />
          </li>
          <li>
            <img
              {...generateSrcSet(
                '/images/ratings/homepage-ico-footer-icon-desktop.svg',
                95,
                56,
              )}
              loading='lazy'
              className='img-fluid'
              alt='ICO Rating Icon'
              width={95}
              height={56}
            />
          </li>
          <li>
            <img
              {...generateSrcSet(
                '/images/ratings/homepage-cloudflare-footer-icon-desktop.svg',
                101,
                62,
              )}
              loading='lazy'
              className='img-fluid'
              alt='SSL Icon'
              width={101}
              height={62}
            />
          </li>
          <li>
            <img
              {...generateSrcSet(
                '/images/ratings/trusted_reviews_icon.svg',
                146,
                31,
              )}
              loading='lazy'
              className='img-fluid fit-content'
              alt='Trusted Reviews Icon'
              width={146}
              height={31}
            />
          </li>
        </ul>
      )}
    </>
  )
}

Ratings.displayName = 'Ratings'
export default Ratings
